<script>
export default {
  data() {
    return {
      old_condition: null,
    };
  },
  created() {
    this.old_condition = this.product.condition;
  },
  computed: {
    product() {
      return this.$store.state.inStock.modal_condition;
    },
    isButtonActive() {
      if (this.product.condition === this.old_condition) return false;

      const isComment = this.product.worker_comment === null || this.product.worker_comment === '';

      return !(this.product.condition !== '0' && isComment);
    },
  },
  methods: {
    save() {
      const data = {
        id: this.product.id,
        data: {
          condition: Number(this.product.condition),
          worker_comment: this.product.worker_comment,
        },
      };

      this.$store.dispatch('is_update_condition', data);
    },

    close(event) {
      if (!event.target.closest('.modal-container') || event.target.classList.contains('close')) {
        this.$store.commit('set_modal_condition', null);
      }
    },
  },
};
</script>
<template src="./change_condition.pug" lang="pug"></template>
